import React, { Fragment } from "react";
import AddButton from "../../Campaign/AddButton";
import EnquireButton from "../../Campaign/EnquireButton";

export default ({
    panel,
    selected,
    refProp,
    showClose,
    onClose,
    isEnquirePage,
    noLinks,
    splitViewPanel,
}) => {
    const Classic = ({ item }) => {
        return (
            <>
                {!noLinks && (
                    <a href={item.link} className="panel__link">
                        <h5 className="panel__name">{item.name}</h5>
                    </a>
                )}
                {item.suburb && <p className="panel__id">{item.suburb}</p>}
                <p className="panel__id">{item.siteID}</p>
                {(item.type === "DigitalBillboard" ||
                    item.type === "ClassicBillboard" ||
                    item.type === "StreetFurniture") && (
                    <p className="panel__size">{item.physicalSize}</p>
                )}
                <p className="panel__description">{item.description}</p>
            </>
        );
    };

    const Bus = ({ item }) => {
        return (
            <>
                {!noLinks && (
                    <a href={item.link} className="panel__link">
                        <h5 className="panel__name">{item.name}</h5>
                    </a>
                )}
                <p className="panel__format">{item.adFormat}</p>
                <p className="panel__description">{item.description}</p>
            </>
        );
    };

    const Train = ({ item }) => {
        return (
            <>
                {!noLinks && (
                    <a href={item.link} className="panel__link">
                        <h5 className="panel__name">{item.name}</h5>
                    </a>
                )}
                {/* <p className="panel__format">{item.adFormat}</p> */}
                <p className="panel__description">{item.description}</p>
            </>
        );
    };

    const Airport = ({ item }) => {
        return (
            <>
                {!noLinks && (
                    <a href={item.link} className="panel__link">
                        <h5 className="panel__name">{item.name}</h5>
                    </a>
                )}
                <p className="panel__id">{item.siteID}</p>
                <p className="panel__id">{item.physicalSize}</p>
                <p className="panel__description">{item.description}</p>
            </>
        );
    };

    const format = () => {
        switch (panel.type) {
            case "Bus":
                return <Bus item={panel} />;
            case "Train":
                return <Train item={panel} />;
            case "Air":
                return <Airport item={panel} />;
            default:
                return <Classic item={panel} />;
        }
    };

    return (
        <div className={`panel ${splitViewPanel && "panel--horizontal"}`}>
            {panel.status && (
                <div className="panel__tag">
                    {panel.status === "New" && <NewTag />}
                    {panel.status === "Upcoming" && <SoonTag />}
                </div>
            )}
            <div className="panel__wrap">
                <div className="panel__inner">
                    <div className="panel__image">
                        {!noLinks ? (
                            <a href={panel.link} className="panel__link">
                                <img src={panel.image} />
                            </a>
                        ) : (
                            <img src={panel.image} />
                        )}
                        <div className="panel__buttons">
                            <span className="panel__location">
                                {panel.city}
                            </span>
                            <div className="panel__actions">
                                <AddButton panel={panel} onRemove={onClose} />
                                {!isEnquirePage && (
                                    <EnquireButton panel={panel} />
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="panel__content">
                        {format()}
                        {!noLinks && (
                            <div className="panel__link-wrapper">
                                <a
                                    href={panel.link}
                                    className="panel__link button"
                                >
                                    {"Find out more"}
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const NewTag = () => (
    <svg
        id="new_with_text"
        data-name="new with text"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 57 30.67"
    >
        <path
            id="Path_12039"
            data-name="Path 12039"
            d="M0 0h57v25H0Z"
            fill="#d46046"
        />
        <path
            id="Path_12038"
            data-name="Path 12038"
            d="m2072.25 3317.67 5.75-5.75h-5.75Z"
            transform="translate(-2021 -3287)"
            fill="#b3383e"
        />
        <path
            id="Path_12040"
            data-name="Path 12040"
            d="M-6.1 0h-1.8l-3.53-6.13V0h-1.68v-8.64h1.9l3.43 6.03v-6.03h1.68Zm7.7-3.77h-4.2v2.22h4.78V0h-6.54v-8.64h6.33v1.53H-2.6v1.84h4.2Zm10.39-4.87h1.83L11.4 0H9.67L8.63-5.05l-.3-1.67-.3 1.67L6.96 0H5.3L2.85-8.64h1.91l1.15 4.95.24 1.38.25-1.35.97-4.98h1.9l1.03 4.95.26 1.37.27-1.32Z"
            transform="translate(29 17)"
            fill="#fff"
        />
    </svg>
);

const SoonTag = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 109.91 30.67">
        <g
            id="coming_soon_with_text"
            data-name="coming soon with text"
            transform="translate(-846.09 -1387)"
        >
            <path
                id="Path_12039"
                data-name="Path 12039"
                d="M0 0h109.66v25H0Z"
                transform="translate(846.09 1387)"
                fill="#3ea2dc"
            />
            <path
                id="Path_12038"
                data-name="Path 12038"
                d="m2072.25 3317.67 5.75-5.75h-5.75Z"
                transform="translate(-1122 -1900)"
                fill="#0067b1"
            />
            <path
                id="Path_12040"
                data-name="Path 12040"
                d="M-81-.65a3.52 3.52 0 0 1-2.47.89 3.73 3.73 0 0 1-2.93-1.2 4.78 4.78 0 0 1-1.06-3.3 4.74 4.74 0 0 1 1.21-3.47 3.61 3.61 0 0 1 2.68-1.07 3.63 3.63 0 0 1 3.2 1.43 3.1 3.1 0 0 1 .6 1.61h-1.8a2.44 2.44 0 0 0-.46-.94 1.83 1.83 0 0 0-1.47-.56 1.8 1.8 0 0 0-1.55.8 3.82 3.82 0 0 0-.57 2.24 3.35 3.35 0 0 0 .6 2.18 1.9 1.9 0 0 0 1.52.72 1.75 1.75 0 0 0 1.45-.62 2.7 2.7 0 0 0 .46-1h1.79A3.88 3.88 0 0 1-81-.64Zm6.4.89a3.77 3.77 0 0 1-2.83-1 4.66 4.66 0 0 1-1.31-3.57 4.57 4.57 0 0 1 1.3-3.56A3.77 3.77 0 0 1-74.6-8.9a3.77 3.77 0 0 1 2.83 1 4.58 4.58 0 0 1 1.3 3.57 4.67 4.67 0 0 1-1.3 3.56A3.77 3.77 0 0 1-74.6.24Zm1.7-2.32a3.55 3.55 0 0 0 .63-2.25 3.54 3.54 0 0 0-.63-2.25 2.06 2.06 0 0 0-1.7-.8 2.09 2.09 0 0 0-1.71.8 3.5 3.5 0 0 0-.64 2.25 3.5 3.5 0 0 0 .64 2.25 2.09 2.09 0 0 0 1.7.8 2.07 2.07 0 0 0 1.71-.8ZM-67.44 0h-1.68v-8.64h2.63l1.57 6.8 1.56-6.8h2.6V0h-1.69v-5.84l.01-.7v-.7L-64.06 0h-1.75l-1.63-7.25v.7q0 .45.02.7Zm8.2-8.64h1.8V0h-1.8ZM-48.77 0h-1.8l-3.53-6.13V0h-1.68v-8.64h1.9l3.43 6.03v-6.03h1.68Zm6.98-.21a3.3 3.3 0 0 1-1.76.44 3.65 3.65 0 0 1-2.82-1.2 4.54 4.54 0 0 1-1.14-3.26 4.8 4.8 0 0 1 1.16-3.36 3.93 3.93 0 0 1 3.05-1.27 3.99 3.99 0 0 1 2.65.84 3.1 3.1 0 0 1 1.14 2.08h-1.77a1.7 1.7 0 0 0-1-1.24 2.46 2.46 0 0 0-1-.19 2.15 2.15 0 0 0-1.7.79 3.58 3.58 0 0 0-.68 2.37 2.94 2.94 0 0 0 .73 2.25 2.39 2.39 0 0 0 1.65.67 2.13 2.13 0 0 0 1.49-.53 2.27 2.27 0 0 0 .71-1.37h-2v-1.44h3.6V0h-1.2l-.18-1.08a4.14 4.14 0 0 1-.94.87Zm10.5-1.04a3.18 3.18 0 0 0 1.04-.14 1 1 0 0 0 .75-1 .74.74 0 0 0-.37-.66 4.03 4.03 0 0 0-1.18-.4l-.91-.2a5.78 5.78 0 0 1-1.87-.67 2.1 2.1 0 0 1-.87-1.87 2.5 2.5 0 0 1 .84-1.93 3.57 3.57 0 0 1 2.48-.77 3.77 3.77 0 0 1 2.33.73 2.58 2.58 0 0 1 1.01 2.1h-1.73a1.24 1.24 0 0 0-.68-1.11 2.28 2.28 0 0 0-1.05-.22 1.96 1.96 0 0 0-1.11.28.9.9 0 0 0-.42.79.74.74 0 0 0 .41.69 5.02 5.02 0 0 0 1.13.35l1.48.36a3.85 3.85 0 0 1 1.48.63 2.11 2.11 0 0 1 .77 1.76 2.49 2.49 0 0 1-.9 1.97 3.8 3.8 0 0 1-2.56.78 4.15 4.15 0 0 1-2.65-.77 2.56 2.56 0 0 1-.97-2.12h1.72a1.77 1.77 0 0 0 .32.89 1.85 1.85 0 0 0 1.51.53ZM-22.6.24a3.77 3.77 0 0 1-2.83-1 4.66 4.66 0 0 1-1.31-3.57 4.57 4.57 0 0 1 1.31-3.56A3.77 3.77 0 0 1-22.6-8.9a3.77 3.77 0 0 1 2.83 1 4.58 4.58 0 0 1 1.3 3.57 4.67 4.67 0 0 1-1.3 3.56A3.77 3.77 0 0 1-22.6.24Zm1.7-2.32a3.55 3.55 0 0 0 .63-2.25 3.54 3.54 0 0 0-.63-2.25 2.06 2.06 0 0 0-1.7-.8 2.09 2.09 0 0 0-1.7.8 3.5 3.5 0 0 0-.65 2.25 3.5 3.5 0 0 0 .64 2.25 2.09 2.09 0 0 0 1.71.8 2.07 2.07 0 0 0 1.7-.8Zm7.63 2.32a3.77 3.77 0 0 1-2.83-1 4.66 4.66 0 0 1-1.3-3.57 4.57 4.57 0 0 1 1.3-3.56 3.77 3.77 0 0 1 2.83-1.01 3.77 3.77 0 0 1 2.83 1 4.58 4.58 0 0 1 1.31 3.57 4.67 4.67 0 0 1-1.3 3.56A3.77 3.77 0 0 1-13.28.24Zm1.7-2.32a3.55 3.55 0 0 0 .64-2.25 3.54 3.54 0 0 0-.63-2.25 2.06 2.06 0 0 0-1.7-.8 2.09 2.09 0 0 0-1.71.8 3.5 3.5 0 0 0-.64 2.25 3.5 3.5 0 0 0 .64 2.25 2.09 2.09 0 0 0 1.7.8 2.07 2.07 0 0 0 1.7-.8ZM-.76 0h-1.8L-6.1-6.13V0h-1.68v-8.64h1.9l3.43 6.03v-6.03h1.68Z"
                transform="translate(945 1404)"
                fill="#fff"
            />
        </g>
    </svg>
);
